export default Object.freeze({
	SGC_ATA_PRORROGACAO: { text: 'Ata Prorrogada', value: 'SGC_ATA_PRORROGACAO' },
})
